
import React from 'react'
import { Route } from 'react-router-dom';

const ProtectedRoute = ({ component: Component, ...rest }) => {

    const cognitoUser = window.userPool.getCurrentUser()

    if (!cognitoUser) {
        window.location = '/user/login?redirect=' + rest.location.pathname + (rest.location.search ? rest.location.search : "")
        return <></>
    } else {
        //TODO: Where?
        var redirect = sessionStorage.getItem("redirect")
        if (redirect) {
            sessionStorage.removeItem("redirect")
            window.location = redirect
            return <></>
        } else {
            return <Route {...rest} render={props => (<Component {...props} {...rest} />)}>
            </Route>
        }
    }
}

export default ProtectedRoute;